import React from 'react';

const SobreMi = () => {
  return (
    <main className='site-width sobre-mi'>
      <div className="texto-sobre-mi">
        <h1>Barber Mujica</h1>
        <p className='subtitulo-sobremi'><strong>BARBERO DESDE 2018</strong></p>
        <p>
          Cuando era niño y comencé a atravesar la complicada etapa de la pubertad, empecé a preocuparme más por mi apariencia y cuidado personal. Si estás aquí, es porque sabes que un buen corte de pelo es fundamental para ello.
          <br /><br />
          Pasé mucho tiempo buscando a un barbero que realmente cumpliera con mis expectativas, pero nunca lo encontré. Hasta que un día pensé:<br />
          «¿Y si lo intento yo? Seguro que no es taaan difícil…»
          <br /><br />
          Mi personalidad perfeccionista y un toque de locura me dieron el valor para probar, y lo que empezó como curiosidad se convirtió en una verdadera pasión.
          <br /><br />
          Hoy, después de años perfeccionando mi técnica, puedo decirte con seguridad:<br />
          – Soy el barbero que tanto buscaste.<br />
          – Si te importa llevar tu estilo al siguiente nivel tanto como me importó a mí en su día… estás en el lugar correcto.
        </p>
      </div>
    </main>
  );
};

export default SobreMi;
